import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import styled from "styled-components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getDatabase, ref, set, onValue } from "firebase/database";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const WealthTracker = () => {
  const [wealth, setWealth] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [income, setIncome] = useState("");
  const [spending, setSpending] = useState("");

  const db = getDatabase();
  const wealthRef = ref(db, "wealthTracker/");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    onValue(wealthRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setWealth(data.currentWealth ?? 0);
        setChartData(data.chartData ?? []);
      }
      setLoading(false);
    });
  }, []);

  // if (loading) return <div>Loading...</div>;

  const handleSubmit = () => {
    const incomeValue = parseFloat(income) || 0;
    const spendingValue = parseFloat(spending) || 0;
    const newWealth = wealth + incomeValue - spendingValue;

    const newChartData = [...chartData];
    const today = new Date().toISOString().split("T")[0];

    if (
      newChartData.length &&
      newChartData[newChartData.length - 1].date === today
    ) {
      newChartData[newChartData.length - 1] = {
        date: today,
        wealth: newWealth,
      };
    } else {
      newChartData.push({ date: today, wealth: newWealth });
    }

    set(wealthRef, {
      currentWealth: newWealth,
      chartData: newChartData,
    })
      .then(() => console.log("Data saved successfully!"))
      .catch((error) => console.error("Error saving data:", error));

    setIncome("");
    setSpending("");
  };

  const lineData = {
    labels: chartData.map((entry) => entry.date),
    datasets: [
      {
        label: "Wealth Over Time",
        data: chartData.map((entry) => entry.wealth),
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
      },
    ],
  };

  return (
    <Container>
      <ChartContainer>
        <Line data={lineData} />
      </ChartContainer>
      <WealthDisplay>Current Wealth: ${wealth}</WealthDisplay>
      <InputContainer>
        <Input
          type="number"
          placeholder="Income"
          value={income}
          onChange={(e) => setIncome(e.target.value)}
        />
        <Input
          type="number"
          placeholder="Spending"
          value={spending}
          onChange={(e) => setSpending(e.target.value)}
        />
        <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
      </InputContainer>
    </Container>
  );
};

export default WealthTracker;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
`;

const ChartContainer = styled.div`
  width: 80%;
  max-width: 800px;
  margin-bottom: 20px;
`;

const WealthDisplay = styled.h2`
  font-size: 24px;
  margin: 10px 0;
`;

const InputContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 150px;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #4caf50;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;
